import { getAPIBaseURL } from './helpers'
import { getData } from './request'

const base = () => `${getAPIBaseURL()}/v1`

/**
 * Get list of centers (public)
 */
export const listCentersPublic = async (params = {}) => {
  const queryParams = new URLSearchParams()
  if (params.search) queryParams.append('search', params.search)
  if (params.country) queryParams.append('country', params.country)
  if (params.city) queryParams.append('city', params.city)
  if (params.includeInactive) queryParams.append('includeInactive', params.includeInactive)
  
  const queryString = queryParams.toString()
  const url = `${base()}/public/centers${queryString ? `?${queryString}` : ''}`
  
  const res = await getData(url, {}, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

/**
 * Get center profile (public)
 */
export const getCenterPublic = async (centerId) => {
  const url = `${base()}/public/centers/${centerId}`
  
  const res = await getData(url, {}, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

/**
 * Get center's media (public)
 */
export const listCenterMediaPublic = async (centerId, type = '') => {
  const url = `${base()}/public/centers/${centerId}/media${type ? `?type=${type}` : ''}`
  
  const res = await getData(url, {}, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

/**
 * Get center's events (public)
 */
export const listCenterEventsPublic = async (centerId) => {
  const url = `${base()}/public/centers/${centerId}/events`
  
  const res = await getData(url, {}, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

/**
 * Get center's offers (public)
 */
export const listCenterOffersPublic = async (centerId) => {
  const url = `${base()}/public/centers/${centerId}/offers`
  
  const res = await getData(url, {}, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

